import React, { useCallback } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import BEMHelper from 'react-bem-helper';
import { reopenApplication } from '@low/guard';

const classes = new BEMHelper('SchemeText');

export const SCHEME_LANDSCAPE = 'landscape';
export const SCHEME_PORTRAIT = 'portrait';

const SchemeTip = ({ className, orientation = '', track }) => {
    const reopenApp = useCallback(() => {
        if (track) track('Open it now');

        reopenApplication();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reopenApplication, track]);

    return (
        // eslint-disable-next-line react/no-unknown-property
        <div {...classes('', '', className)} scheme-orientation={orientation}>
            {i18n.t('DOWNLOAD.alreadyInstalled.FIRST', {
                applicationName: i18n.t('DOWNLOAD.APPLICATION'),
            })}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={reopenApp} data-at='DownloadPage::Button::ReopenApp'>
                {i18n.t('DOWNLOAD.alreadyInstalled.LINK')}
            </a>
            {i18n.t('DOWNLOAD.alreadyInstalled.LAST')}
        </div>
    );
};

SchemeTip.propTypes = {
    className: PropTypes.string,
    orientation: PropTypes.oneOf([SCHEME_LANDSCAPE, SCHEME_PORTRAIT]),
    track: PropTypes.func,
};

export default SchemeTip;
